const validate = (values, nameRequired) => {
  const errors = {};

  if (!values.purchase_ship_contact && nameRequired) {
    errors.purchase_ship_contact = 'Required';
  }

  return errors;
};

export default validate;